import '../../styles/sections/plan-choice.scss';

import { addToCart } from '../utils/cart';

class PlanChoice extends HTMLElement {
  constructor() {
    super();
    this.programs = this.querySelectorAll('[data-program]');
    this.forms = this.querySelectorAll('[data-add-to-cart]');

    this.programs.forEach(program => {
      program.addEventListener('click', this.selectProgram.bind(this));
    });

    this.forms.forEach(form => {
      form.addEventListener("submit", (e) => {
        e.preventDefault();
        this.addToCart(form)
      })
    });
  }

  selectProgram(e) {
    const currentProgram = this.querySelector('[program-selected]');
    const currentProgramTarget = this.querySelector('.js-program-active')
    const program = e.target.closest('[data-program]');
    const target = this.querySelector(`[data-program-target="${program.dataset.program}"]`)

    currentProgram.removeAttribute('program-selected');
    program.setAttribute('program-selected', '');

    currentProgramTarget.classList.remove('js-program-active');
    target.classList.add('js-program-active');
  }

  async addToCart(form) {
    localStorage.setItem('trainer', form.dataset.trainer);

    const formData = new FormData(form);

    await addToCart(formData.get('id'), 1, formData.get('selling_plan'));
  }
}

customElements.define('plan-choice', PlanChoice)
